<template>
  <div style="padding: 20px">
    <Row :gutter="16">
      <Col :md="6">
        <Card>
          <h1>{{ company.name }}</h1>
          <br>
          <p>Email: <b>{{ company.email || '-' }}</b></p>
          <p>Telefono: <b>{{ company.telephone || '-' }}</b></p>
          <p>Fax: <b>{{ company.fax || '-' }}</b></p>
          <p>Indirizzo:
            <br><b>{{ company.addr_street }}</b>
            <br><b>{{ company.addr_city }}</b> <b>{{ company.addr_zip }}</b>
          </p>
        </Card>
        <br>
        <Card>
          <h2>
            <Icon type="android-search" :size="30"/>
            Grandezza testi
          </h2>
          <br>
          <Select v-model="zoom" @on-change="$utils.setZoom($event)">
            <Option value="1">Piccolo</Option>
            <Option value="1.2">Medio</Option>
            <Option value="1.5">Grande</Option>
          </Select>
        </Card>

        <br>

        <card>
          <h2>
            <Icon type="document-text" :size="30"/>
            &nbsp;
            Ultimi aggiornamenti
          </h2>
          <br>
          <div class="updates" style="overflow: auto; max-height: 300px">
            <b>1.0.23 - 10 Febbraio 2020</b>
            <ul>
              <li>Aggiunta percentuale ammortamento nelle impostazioni</li>
            </ul>
            <b>1.0.22 - 7 Febbraio 2020</b>
            <ul>
              <li>Aggiunta filtro fatture sospese</li>
            </ul>
            <b>1.0.21 - 4 Febbraio 2020</b>
            <ul>
              <li>Miglioramento movimenti in partita doppia</li>
            </ul>
            <b>1.0.20 - 8 Aprile 2019</b>
            <ul>
              <li>Miglioramento registrazione rapida soci</li>
              <li>Aggiunti saldi nel bilancio</li>
            </ul>
            <b>1.0.19 - 4 Aprile 2019</b>
            <ul>
              <li>Miglioramento partitario</li>
            </ul>
            <b>1.0.18 - 21 Marzo 2019</b>
            <ul>
              <li>Inversione saldi partitario per conto economico</li>
            </ul>
            <b>1.0.17 - 19 Marzo 2019</b>
            <ul>
              <li>Aggiunto calcolo IRES</li>
            </ul>
            <b>1.0.16 - 11 Marzo 2019</b>
            <ul>
              <li>Fix bilancio</li>
            </ul>
            <b>1.0.15 - 5 Marzo 2019</b>
            <ul>
              <li>Fix apertura/chiusura anno</li>
              <li>Ottimizzazione velocità</li>
            </ul>
            <b>1.0.14 - 27 Febbraio 2019</b>
            <ul>
              <li>Aggiunta gestione beni</li>
              <li>Aggiunta stampa beni</li>
            </ul>
            <b>1.0.13 - 26 Febbraio 2019</b>
            <ul>
              <li>Aggiunti saldi in bilancio</li>
              <li>Miglioramento esportazioni</li>
              <li>Fix iva</li>
            </ul>
            <b>1.0.12 - 18 Febbraio 2019</b>
            <ul>
              <li>Numero di protocollo nelle fatture</li>
              <li>Ridotta dimensione tabelle</li>
              <li>Migliorata importazione da bartolomeo</li>
              <li>Eliminazione fatture</li>
              <li>Ordinamenti e filtri nelle fatture</li>
            </ul>
            <b>1.0.11 - 8 Febbraio 2019</b>
            <ul>
              <li>Attivata registrazione rapida soci: vai nelle impostazioni per attivarla</li>
              <li>Data pagamento nel rilascio tessere</li>
              <li>Calcolo IVA automatico</li>
            </ul>
            <b>1.0.10 - 2 Febbraio 2019</b>
            <ul>
              <li><b>Soci:</b></li>
              <li>È possibile stampare la ricevuta per la registrazione dei soci (disponibile solo per le nuove registrazioni)</li>
              <li>Quando i soci vengono tesserati con un importo superiore a quello della tessera, l'eccedenza viene messa nel conto "Erogazione Liberale"</li>
              <li>Ordinamento per Numero Socio crescente</li>
              <li><b>Contabilità:</b></li>
              <li>Corretta stampa bilancio</li>
              <li>Corretta apertura anno</li>
              <li>Abilitate fatture anche per utenti non-IVA</li>
              <li>Battimento mese data di nascita da tastiera</li>
            </ul>
            <b>1.0.9 - 1 Febbraio 2019</b>
            <ul>
              <li>Divisa la stampa tra piano dei conti e bilancio</li>
            </ul>
            <b>1.0.8 - 29 Gennaio 2019</b>
            <ul>
              <li>Migliorato inserimento data nascita soci</li>
            </ul>
            <b>1.0.7 - 23 Gennaio 2019</b>
            <ul>
              <li>Migliorata esportazione contabilità</li>
            </ul>
            <b>1.0.6 - 22 Gennaio 2019</b>
            <ul>
              <li>Creazione procedura apertura anno</li>
              <li>Corretta data inglese</li>
              <li>Compilazione data nascita</li>
              <li>Duplice esportazione prima nota</li>
            </ul>

            <b>1.0.5 - 16 Gennaio 2019</b>
            <ul>
              <li>Fix data di nascita soci</li>
              <li>Stampa bilancio in pdf</li>
              <li>Stampa prima nota in pdf</li>
            </ul>

            <b>1.0.4 - 15 Gennaio 2019</b>
            <ul>
              <li>Partitario nella pagina dei conti</li>
              <li>Miglioramento registro dei beni</li>
              <li>Importazione dei beni da Bartolomeo</li>
            </ul>

            <b>1.0.3 - 9 Gennaio 2019</b>
            <ul>
              <li>Aggiunto il registro dei beni: un bene verrà aggiunto automaticamente se una fattura/ricevuta da fornitore movimenterà il conto 145 o 150.</li>
            </ul>

            <b>1.0.2 - 8 Gennaio 2019</b>
            <ul>
              <li>Cambiato periodo di visualizzazione nella prima nota</li>
              <li>Fix utilizzo buoni</li>
            </ul>

            <b>1.0.1 - 5 Gennaio 2019</b>
            <ul>
              <li>Aggiunta esportazione prima nota</li>
            </ul>
          </div>
        </card>
      </Col>
      <Col :md="18">
        <Card v-if="!$store.company.is_initialized" style="margin-bottom: 1em">
          <h1>Primo Accesso</h1>
          <hr>
          <p>
            Benvenuto in <b>{{ $store.config.NAME }}</b>, il software di <b>FederCentri</b>
            per la gestione dei soci e della contabilità del tuo Centro.
          </p>
          <p>
            Tramite il menu in alto puoi spostarti nelle varie sezioni.
          </p>
          <br>
          <h1>Importazione dei dati da Bartolomeo</h1>
          <hr>
          <p>
            Se hai bisogno di importare i dati dal gestionale Bartolomeo di Ancescao,
            clicca su "<a @click="$router.push({name:'import'})">Importa</a>" o vai nella sezione "<a @click="$router.push({name:'settings'})">Impostazioni</a>".
          </p>
          <p>
            Questa funzionalità deve essere usata solamente nella fase iniziale.
          </p>
          <br>
          <h1>Configurazione</h1>
          <hr>
          <p>
            Puoi configurare i tuoi dati nella sezione "<a @click="$router.push({name:'settings'})">Impostazioni</a>".
          </p>
          <br>
          <Button @click="$http.post('initialized', { company_id: $store.company.id }).then(res => $store.company = res.data)">Nascondi questo avviso</Button>
        </Card>
        <Row :gutter=16>
          <Col :md="6">
            <Card class="text-center pointer" @click.native="$router.push('soci')" style="color: #9999ff">
              <h2>Soci</h2>
              <Icon type="ios-people-outline" :size="100"/>
            </Card>
          </Col>
          <Col :md="6">
            <Card class="text-center pointer" @click.native="$router.push('contabilita')" style="color: var(--info-color)">
              <h2>Contabilità</h2>
              <Icon type="ios-list-outline" :size="100"/>
            </Card>
          </Col>
          <Col :md="6">
            <Card class="text-center pointer"
            @click.native="$root.$emit('invoice.show', {is_a:'ric', items: []})"
            style="color: #82C324">
              <h2>Ricevuta</h2>
              <Icon type="cash" :size="100"/>
            </Card>
          </Col>
          <Col :md="6">
            <Card class="text-center pointer" @click.native="$router.push('impostazioni')" style="color: #ff884d">
              <h2>Impostazioni</h2>
              <Icon type="gear-a" :size="100"/>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>


<script type="text/javascript">
export default {
  store: [
    'company',
  ],
  data () {
    return {
      zoom: ''+this.$utils.getZoom(),
      ledgers: null,
    }
  },
  mounted() {
    var params = {company_id:this.$store.company.id}
    this.$http.get('ledgers', {params}).then(res => {
      this.ledgers = res.data
    })
  }
}
</script>

<style lang="scss">
code {
  opacity: 0.6;
}
pre {
  max-width: 100%;
  overflow: auto;
  margin-bottom: 40px;
}
.updates {
  ul {
    margin-bottom: 10px;
    font-size: 90%;
    li {
      padding-left: 1em;
      text-indent: -1em;

      &:before {
        content: "-";
        padding-right: 5px;
        padding-left: 5px;
      }
    }
  }
}
</style>
